import QueryForm from "../forms/QueryForm";
import {Grid, SegmentedControl, Modal,  WingBlank, WhiteSpace, Button, ActivityIndicator} from "antd-mobile";
import React, {useEffect, useRef, useState} from "react";
import PropTypes from 'prop-types';
import {useToggle} from "../lib/hooks";
import {useSearch} from "../lib/bridgeHooks";
import {includes} from 'lodash';


export default function StepTwo({
        setTemplate, template,
        setBlackAndWhite, blackAndWhite,
        defaultKeyword='', company,
        user, adServices, recordsChanged=()=>{},
        hideQuery=false,
        ...props}) {

    const [columns, setColumns] = useState(2);
    const [isBnw, toggleBnw] = useToggle();
    const [visible, setVisible] = useState(false);
    const [index, setIndex] = useState();

    const [response, sendQuery] = useSearch('mobileWizard');
    const [records, setRecords] = useState([]);
    const [batch, setBatch] = useState(0);
    const [total, setTotal] = useState(0);
    const [query, setQuery] = useState();
    const lastQuery = useRef();

    // todo more cohesive search/query/results/selection object

    const onChange = (e) => {
        setColumns(e.nativeEvent.selectedSegmentIndex+1);
    };

    useEffect(()=>{
        if (response.status==='success'){
            if (lastQuery.current === response.query) {
                setRecords(recs => recs.concat(response.results.records));
                setTotal(response.results.total);
            }
        }
        //todo would failure leave pres search hanging?  would it matter
    },[response]);

    useEffect(()=>{
        recordsChanged(records);
    },[records]);

    useEffect(()=>{
        if (batch>0 && query) {
            if (batch===1) {
                setIndex(null);
                setRecords(recs => recs.length ? [] :recs);
                setTotal(0);
            }
            lastQuery.current = query;
            sendQuery(query, {page: batch});
        }
    },[batch,query ]);

    const [key, setKey] = useState(0);

    useEffect(()=>{
        setKey(k=>k+1);
        // force a remount and resetting of initial values
    },[company]);


    return <div className={'mm-results'}>
         <QueryForm
            style={hideQuery ?{display:'none'} :{}}
            key={key}   // forece reset when company changes
            defaultKeyword={defaultKeyword}
            onChange={(query) => {
                setBatch(1);
                setQuery(query);
            }}
            showHolidayToggle={includes(adServices, 'Holiday Adv. Service') &&
                (new Date()).getMonth() >= 8}
        />
        <div className={'am-list-header'}>Select a template</div>
        <SegmentedControl
            values={["1 across", "2 across", "3 across"]}
            onChange={onChange}
            selectedIndex={columns - 1}
        />


        {records.length !== 0 &&
            <Grid
                data={records}
                columnNum={columns}
                square={false}
                onClick={(obj, index) => {
                    setIndex(index);
                    setVisible(true);
                }}
                activeStyle={{backgroundColor: 'gray'}}
                className={'no-padding'}
                renderItem={(dataItem, displayIndex) => (
                    <div
                        style={{padding: '5px'}}
                        className={template && (template.name === dataItem.name) ? 'selected-template' : ''}>
                        <img
                            src={columns === 1 ? dataItem.getPreviewUrl() : dataItem.getThumbUrl()}
                            alt=""
                            style={{maxWidth: '100%'}}/>
                    </div>
                )}
            />
        }
        <WhiteSpace/>
        { response.status==='loading' && records.length===0 &&
            <WingBlank >
                <ActivityIndicator/>
            </WingBlank>
        }
        { records.length!==0 && total>records.length && user !== 'guest' &&
                <WingBlank>
                    <Button
                        onClick={() => setBatch(batch+1)}
                        disabled={response.status==='loading'}
                        loading={response.status==='loading'}
                    >
                        load more
                    </Button>
                </WingBlank>
        }
        {  user === 'guest' &&
            <WingBlank>
                <p>To see more ad templates please login.</p>
            </WingBlank>
        }
        <WhiteSpace/>

        <SelectTemplate
            {...{visible,isBnw,toggleBnw}}
            asset={records[index]}
            onCancel={() => setVisible(false)}
            onSelect={() => {
                setBlackAndWhite(isBnw);
                setTemplate(records[index]);
                setVisible(false);
            }}
            onClose={() => setVisible(false)}
            />
    </div>;
}
StepTwo.propTypes = {
    setTemplate: PropTypes.func.isRequired
};


// todo ?is this the right spot for B&W (put on company screen?)
function SelectTemplate({asset={},isBnw,toggleBnw,onCancel,onSelect, ...props}) {
    return <Modal
        title={asset.name}
        transparent
        footer={[
            {text: "Cancel", onPress: onCancel},
            {text: "Select template", onPress: onSelect},
        ]}
        {...props}  //onClose, visible
    >
        {asset.name && <img
            src={asset.getPreviewUrl()}
            alt={asset.name}
            style={{width: "100%"}}
        />}
    </Modal>;
}
SelectTemplate.propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func,
    onSelect: PropTypes.func,
    onClose: PropTypes.func,
    isBnw: PropTypes.bool,
    toggleBnw: PropTypes.func,
    asset: PropTypes.object // mcc.Asset
};

/*
        <SingleSwitch
            checked={isBnw}
            onChange={toggleBnw}
        >Black & White</SingleSwitch>

 */


/*
This doesn't work on ipad - messes up scrolling

<PullToRefresh
                    damping={60}
                    direction={'up'}
                    indicator={{
                        activate:'release to load',
                        deactivate:'Pull up to see more templates',  //initial
                        //release:'loading...',  //?? default is spinner
                        finish:'Pull up to see more templates'
                    }}
                    refreshing={response.status==='loading'}
                    onRefresh={() => setBatch(batch+1)}
                >
 */